import * as firebase from 'firebase'
import 'firebase/firestore'

import { GetterTree, MutationTree, ActionTree } from 'vuex';
import { RootState } from '@/store'
import Company, { CompanyUser } from '@/models/Company'
import CompanyService from '@/services/CompanyService'
const companyService = new CompanyService()

const subscriptionsTypes = ['free', 'enhanced', 'unlimited'];
const subscriptions = [
  {
    id: 'free',
    products: 3,
    templates: 1,
    projects: 1,
    users: 1,
  },
  {
    id: 'enhanced',
    products: 30,
    templates: 3,
    projects: 2,
    users: 3,
  },
  {
    id: 'unlimited',
    products: 9999999,
    templates: 9999999,
    projects: 9999999,
    users: 9999999,
  },
];

export interface CompanyState {
  company: Company | null;
  users: Array<CompanyUser>;
}

const state: CompanyState = {
  company: null,
  users: []
}


const mutations: MutationTree<CompanyState> = {
  SET_COMPANY(state: any, company: Company) {
    state.company = company
  },
  ADD_USER(state: any, item: any) {
    state.users.push(item)
  },
}

const actions: ActionTree<CompanyState, any> = {
  async syncCompany({ commit }, companyId: string) {
    await firebase.firestore()
      .collection('companies')
      .doc(companyId)
      .onSnapshot((doc: any) => {
        const item = doc.data() as Company
        item.id = doc.ref.id
        item.added = doc.data().added ? doc.data().added.toDate() : null
        item.updated = doc.data().updated ? doc.data().updated.toDate() : null
        commit('SET_COMPANY', item)
      });
  },
  async fetchCompany({ commit, dispatch }, userId: string) {
    const company = await companyService.fetchCompanyByUserId(userId);
    if (company && company.length) {
      dispatch('syncCompany', company[0].id)
      return company[0];
    } else {
      return null;
    }
  },
  async fetchCompanyUsers({ commit }, companyId) {
    await companyService.fetchCompanyUsers(companyId)
      .then((users) => {
        if (users.length) {
          users.forEach((user: any) => {
            commit('ADD_USER', user)
          })
        }
      })
  },
  async updateCompany({ commit }, item: Company) {
    return await companyService.updateCompany(item)
      .then((res) => {
        if (res) {
          commit('SET_COMPANY', item)
          return item
        } else {
          return false;
        }
      })
      .catch((error) => {
        console.log('catched error in store', error)
        return error
      })

  },
}

const getters: GetterTree<CompanyState, RootState> = {
  getCompany: (state: any) => {
    return state.company
  },
  getUsers: (state: any) => {
    return state.users
  },
  getSubscription: (state: any) => {
    if (state.company && state.company.subscriptionStatus && state.company.subscriptionStatus === 'active') {
      return {
        'status': state.company.subscriptionStatus,
        'type': state.company.subscriptionType,
        'premium': state.company.subscriptionStatus === 'active'
          && subscriptionsTypes.includes(state.company.subscriptionType)
          && state.company.subscriptionType != 'free',
      }
    } else {
      return null
    }
  },
  getAccess: (state: any) => {
    if (state.company) {

      const sub: string =
        state.company.subscriptionType && state.company.subscriptionStatus === 'active' && subscriptionsTypes.includes(state.company.subscriptionType) ?
          state.company.subscriptionType : 'free';

      const access = subscriptions.find((item) => { return item.id === sub })
      const quantity = state.company.quantity;

      if (access) {
        return {
          products: access.products > (quantity.products ? quantity.products : 0),
          templates: access.templates > (quantity.templates ? quantity.templates : 0),
          projects: access.projects > (quantity.projects ? quantity.projects : 0),
          users: access.users > (quantity.users ? quantity.users : 0),
        }
      } else {
        return {
          products: false,
          templates: false,
          projects: false,
          users: false,
        }
      }
    }

  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
